<template>
  <div class="createContent">
    <div class="editLine row flex-center">
      <div class="editLine-title">归属门店 <span class="fc-red">*</span></div>
      <div
        class="flex-1"
        v-if="form.clinicId.length > 0"
        @click="selectClinic()"
      >
        {{ form.clinicName }}
      </div>
      <div v-else class="flex-1 deffont" @click="selectClinic()">
        请选择门店
      </div>
      <div class="iconfont icon-xiangyoujiantou"></div>
    </div>

    <div class="editLine row flex-center">
      <div class="editLine-title">姓名<span class="fc-red">*</span></div>
      <div class="flex-1">
        <input
          class="inputbox"
          maxlength="32"
          placeholder="请输入姓名"
          v-model.trim="form.patientName"
        />
      </div>
    </div>

    <div class="editLine row flex-center">
      <div class="editLine-title">证件类型</div>
      <div class="flex-1 row flex-center" @click="selectIdcardType">
        <div class="flex-1" v-if="idcardTypeConfig.idcardType">
          {{ idcardTypeConfig.idcardTypeText }}
        </div>
        <div class="flex-1 deffont" v-else>请选择证件类型</div>
        <div class="iconfont icon-xiangyoujiantou"></div>
      </div>
    </div>

    <div class="editLine row flex-center">
      <div class="editLine-title">证件号码</div>
      <div class="flex-1">
        <input
          class="inputbox"
          v-model.trim="idcardTypeConfig.idcard"
          maxlength="30"
          placeholder="请输入证件号码"
          @input="onIdcardInputChange"
        />
      </div>
    </div>

    <div class="editLine row flex-center">
      <div class="editLine-title">手机号码<span class="fc-red">*</span></div>
      <div class="flex-1">
        <input
          class="inputbox"
          v-model.trim="form.phone1"
          maxlength="15"
          placeholder="请输入手机号码"
          type="tel"
          @input="onInputChange"
        />
      </div>
    </div>

    <!-- <div class="editLine row flex-center">
      <div class="editLine-title">患者类型<span class="fc-red">*</span></div>
      <div class="flex-1 row">
        <div
          class="sexBtn"
          v-for="(row, index) in patientTypeOptions"
          :key="index"
          :class="form.patientType == row ? 'active' : ''"
          @click="form.patientType = row"
        >
          {{ row }}
        </div>
      </div>
    </div> -->

    <div class="editLine row flex-center">
      <div class="editLine-title">性别<span class="fc-red">*</span></div>
      <div class="flex-1 row">
        <div
          class="sexBtn"
          v-for="(row, index) in sexList"
          :key="index"
          :class="form.sex == row.value ? 'active' : ''"
          @click="form.sex = row.value"
        >
          {{ row.name }}
        </div>
        <!-- <div class="sexBtn" :class="form.gender=='女'?'active':''">女</div>

        <div class="sexBtn" :class="form.gender=='未知'?'active':''">未知</div> -->
      </div>
    </div>

    <div class="editLine row flex-center">
      <div class="editLine-title">下次补充生日年龄</div>
      <div class="flex-1 row flex-center">
        <div class="flex-1"></div>
        <van-switch
          class="endswitch"
          v-model="form.isUnkownBirthday"
          :active-color="'#28b8c3'"
          :size="24"
          :active-value="'1'"
          :inactive-value="'0'"
        />
      </div>
    </div>

    <div class="editLine row flex-center">
      <div class="editLine-title">
        出生日期 <span v-if="form.isUnkownBirthday == 0" class="fc-red">*</span>
      </div>
      <div class="flex-1 row flex-center">
        <div
          class="flex-1 deffont"
          v-if="form.birthday == ''"
          @click="showBirthDate()"
        >
          请选择出生日期
        </div>
        <div class="flex-1" v-else @click="showBirthDate()">
          {{ form.birthday }}
        </div>
        <!-- <div
          class="endbtn"
          :class="form.isUnkownBirthday == 1 ? 'active' : ''"
          @click="updateUnknownBirthday"
        >
          未知
        </div> -->
      </div>
    </div>

    <div class="editLine row flex-center">
      <div class="editLine-title">
        年龄 <span v-if="form.isUnkownBirthday == 0" class="fc-red">*</span>
      </div>
      <div class="flex-1 row flex-center">
        <div class="flex-1">
          <input
            class="inputbox"
            placeholder="请输入年龄"
            v-model.trim="form.age"
            maxlength="4"
            type="number"
            pattern="[0-9]*"
            @change="calculateBirthdayByAge"
          />
        </div>
      </div>
    </div>

    <div class="editLine row flex-center">
      <div class="editLine-title">患者来源<span class="fc-red">*</span></div>
      <div class="flex-1 row flex-center">
        <div class="flex-1" @click="showStep1()" v-if="source.sourceId1 != ''">
          {{ source.sourceName1 }}
        </div>
        <div class="flex-1 deffont" @click="showStep1()" v-else>请选择</div>
        <div class="iconfont icon-xiangyoujiantou"></div>
      </div>
    </div>

    <div class="editLine row flex-center" v-if="source.sourceId1 != ''">
      <div class="editLine-title"></div>
      <div class="flex-1 row flex-center">
        <div class="flex-1" @click="showStep2()" v-if="source.sourceId2 != ''">
          {{ source.sourceName2 }}
        </div>
        <div class="flex-1 deffont" @click="showStep2()" v-else>请选择</div>
        <div class="iconfont icon-xiangyoujiantou"></div>
      </div>
    </div>

    <div
      class="editLine row flex-center"
      v-if="source.sourceId2 != '' && testShowSourceId3()"
    >
      <div class="editLine-title"></div>
      <!--正常的下拉-->
      <div class="flex-1 row flex-center" v-if="source.source3Type == 0">
        <div class="flex-1" v-if="source.sourceId3 != ''" @click="showStep3()">
          {{ source.sourceName3 }}
        </div>
        <!-- <div class="flex-1 deffont"  v-else-if="sourceOptions3.length == 0">无三级来源</div> -->
        <div class="flex-1 deffont" v-else @click="showStep3()">请选择</div>
        <div class="iconfont icon-xiangyoujiantou"></div>
      </div>

      <!--选择员工-->

      <div class="flex-1 row flex-center" v-if="source.source3Type == 1">
        <div
          class="flex-1"
          v-if="source.sourceId3 != ''"
          @click="showEmptTip()"
        >
          {{ source.sourceName3 }}
        </div>
        <div class="flex-1 deffont" v-else @click="showEmptTip()">请选择</div>
        <div class="iconfont icon-xiangyoujiantou"></div>
      </div>

      <!--选择患者-->
      <div class="flex-1 row flex-center" v-if="source.source3Type == 2">
        <div
          class="flex-1"
          v-if="source.sourceId3 != ''"
          @click="selectEmpTipShow()"
        >
          {{ source.sourceName3 }}
        </div>
        <div class="flex-1 deffont" v-else @click="selectEmpTipShow()">
          请选择
        </div>
        <div class="iconfont icon-xiangyoujiantou"></div>
      </div>
    </div>

    <div class="editLine row flex-center">
      <div class="editLine-title">工作单位 <span class="fc-red">*</span></div>
      <div class="flex-1 row flex-center" @click="selectWorkshow()">
        <div v-if="form.workUnit != ''" class="flex-1">{{ form.workUnit }}</div>
        <div v-else class="deffont flex-1">请选择</div>
      </div>
      <div
        v-if="form.workUnit != ''"
        class="iconfont deleteicon icon-shanchu"
        @click="deleteWork()"
      ></div>
    </div>
  </div>

  <!--选择门店-->
  <SelectStore
    v-if="selectStoreTip.isShow"
    :clinicList="clinicList"
    :self="selectStoreTip"
    @storeChange="clinicOnConfirm"
  >
  </SelectStore>

  <!--选择时间-->
  <TimeSelect
    v-if="selectTime.isShow"
    :self="selectTime"
    @confirm="timeConfirm"
  >
  </TimeSelect>

  <!--患者来源1-->
  <Step1
    v-if="step1Tip.isShow"
    :self="step1Tip"
    :optinos="sourceOptions1"
    @select="step1Select"
  ></Step1>

  <!--患者来源2-->
  <Step2
    v-if="step2Tip.isShow"
    :self="step2Tip"
    :optinos="sourceOptions2"
    @select="step2Select"
  ></Step2>

  <!--患者来源3-->

  <Step3
    v-if="step3Tip.isShow"
    :self="step3Tip"
    :optinos="sourceOptions3"
    @select="step3Select"
  ></Step3>

  <!--患者来源3-->

  <!--患者来源选择员工-->
  <SelectEmployee
    v-if="selectEmployeeTip.isShow"
    :options="empOptions"
    :self="selectEmployeeTip"
    @empChange="empChange"
  >
  </SelectEmployee>
  <!--患者来源选择员工END-->

  <!--患者来源选择患者-->
  <SelectPatient
    v-if="selectPatientTip.isShow"
    :self="selectPatientTip"
    @select="selectPatientClick"
  >
  </SelectPatient>
  <!--患者来源选择患者END-->

  <!--选择工作单位-->
  <SelectWorkUnit
    v-if="SelectWorkUnitTip.isShow"
    :self="SelectWorkUnitTip"
    @workChange="selectWork"
  >
  </SelectWorkUnit>
  <!--选择工作单位END-->

  <!--选择证件类型-->
  <IdcardTypeSelect
    v-if="idcardTypeConfig.isShow"
    :self="idcardTypeConfig"
    :options="idcardTypeList"
    @confirm="confirmIdcardType"
  >
  </IdcardTypeSelect>
  <!--选择证件类型END-->
</template>

<script>
import { getClinicList, getClinicListbyEmp } from "@/api/options.js";
import { userStore } from "@/store/user.js";
import SelectStore from "@/components/publick/selectStore.vue";
import TimeSelect from "@/components/publick/timeSelect.vue";
import func from "@/util/func.js";
import moment from "moment";
import { systemStore } from "@/store/system";
import {
  quickCreateQWPatientRecord,
  sourceList,
  WeChatBindCustomer,
  getUserLeads,
} from "@/api/createpatient.js";
import Step1 from "@/components/publick/source/step1.vue";
import Step2 from "@/components/publick/source/step2.vue";
import Step3 from "@/components/publick/source/step3.vue";
import SelectEmployee from "@/components/publick/selectEmployee.vue";
import SelectPatient from "@/components/publick/selectPatient.vue";
import SelectWorkUnit from "@/components/publick/selectWorkUnit.vue";
import { contactCardProps, showToast } from "vant";
import { getPublickOptions } from "@/util/getoptions.js";
import { loadingStore } from "@/store/loading.js";
import { inject } from "vue";
import IdcardTypeSelect from "@/components/publick/idcardTypeSelect.vue";

export default {
  name: "createRecord",
  props: {},
  setup() {
    const system_store = systemStore();
    let loading = loadingStore();
    const GetCustomerInformation = inject("GetCustomerInformation");
    return {
      system_store,
      loading,
    };
  },
  data() {
    return {
      form: {
        clinicName: "",
        clinicId: [],
        patientName: "",
        phone1: "",
        sex: "",
        birthday: "",
        patientType: "临时", //患者类型
        isUnkownBirthday: 0, // 是否确认生日（1 未知 0已知和 空）
        age: "",
        workUnit: "", //工作单位
      },
      source: {
        //患者的三级来源
        sourceId1: "", // 患者来源id1
        sourceName1: "",
        sourceId2: "", // 患者来源id2
        sourceName2: "",
        showSourceId3: true,
        source3Type: 0, // 0正常的下拉  1选择员工
        sourceId3: "", // 患者来源id3
        sourceName3: "",
      },
      sourceOptions1: [], //一级来源
      sourceOptions2: [], //二级来源
      sourceOptions3: [], //三级来源
      idcardTypeList: [], //患者证件类型列表
      empOptions: [], //员工下拉
      patientTypeOptions: ["普通", "临时"], //患者类型
      selectStoreTip: {
        isShow: false,
        current: "",
      },
      currentSelectTime: {},
      selectTime: {
        isShow: false,
        minDate: null,
        maxDate: null,
        currentDate: null,
      },
      sexList: [],
      step1Tip: {
        isShow: false,
        current: "",
      },
      step2Tip: {
        isShow: false,
        current: "",
      },
      step3Tip: {
        isShow: false,
        current: "",
      },
      selectEmployeeTip: {
        //选择员工
        isShow: false,
        title: "",
        current: "",
      },
      idcardTypeConfig: {
        //证件类型
        isShow: false,
        idcardType: "", //证件类型
        idcardTypeText: "", //证件类型
        idcard: "", //证件号码
      },
      selectPatientTip: {
        //选择患者
        isShow: false,
        title: "",
        clinicId: "",
        current: "",
      },
      SelectWorkUnitTip: {
        isShow: false,
        current: "", //当前工作单位
      },
    };
  },
  components: {
    SelectStore,
    TimeSelect,
    Step1,
    Step2,
    Step3,
    SelectEmployee,
    SelectPatient,
    SelectWorkUnit,
    IdcardTypeSelect,
  },
  mounted() {
    // Your mounted logic here
    this.getOptions();
    this.formatUser();
  },
  methods: {
    // Your methods here
    formatUser() {
      //获取用户姓名和手机号
      let that = this;
      const user = userStore();

      getUserLeads({
        agentId: user.agentId,
        corpId: user.corpId,
        cusId: user.cusId,
      }).then((res) => {
        let { remark, remarkMobiles, gender } = res.data.data || {};

        if (!func.isEmpty(remark)) {
          that.form.patientName = remark;
        }

        if (!func.isEmpty(remarkMobiles)) {
          that.form.phone1 = remarkMobiles;
        }

        if (!func.isEmpty(gender)) {
          if (gender == 1) {
            that.form.sex = 1;
          } else if (gender == 2) {
            that.form.sex = 2;
          }
        }
      });
    },
    getOptions() {
      let that = this;

      //获取诊所
      getClinicListbyEmp().then((res) => {
        let { data } = res.data;
        data.forEach((item) => {
          item.text = item.name;
        });

        that.clinicList = data;

        //默认取归属诊所
        const user = userStore();
        let item = that.clinicList.find((item) => {
          return item.value == user.userInfo.detail.clinic_id;
        });
        if (!func.isEmpty(item)) {
          that.form.clinicName = item.name;
          that.form.clinicId = [item.value];
          that.getSource1();
        }
      });

      //获取性别
      this.system_store.setSysOptions("SEX").then((res) => {
        this.sexList = res;
      });

      //获取证件类型
      this.getIdcardType();
    },
    //获取证件类型
    getIdcardType() {
      this.system_store.setSysOptions("HIS_PATIENT_IDCARD_TYPE").then((res) => {
        this.idcardTypeList = res;
      });
    },
    selectClinic() {
      let that = this;
      this.selectStoreTip.current = this.form.clinicId[0];
      this.selectStoreTip.isShow = true;
    },
    clinicOnConfirm({ row }) {
      let that = this;
      const selectedValues = row.value;
      let { clinicList } = that;

      let item = clinicList.find((item) => {
        return item.value == selectedValues;
      });

      that.form.clinicName = item.name;
      that.form.clinicId = [item.value];

      this.selectStoreTip.isShow = false;
      //获取一级来源
      that.clearSource();
      that.getSource1();
    },
    showBirthDate() {
      let that = this;

      this.selectTime.maxDate = new Date();

      if (!func.isEmpty(that.form.birthDate)) {
        this.selectTime.currentDate = [
          moment(that.form.birthDate).format("YYYY"),
          moment(that.form.birthDate).format("MM"),
          moment(that.form.birthDate).format("DD"),
        ];
      }

      this.selectTime.isShow = true;
    },
    timeConfirm(e) {
      let that = this;
      let { valueStr } = e;
      that.currentSelectTime = e;

      let birth = moment(valueStr);
      let today = moment();
      let year = today.diff(birth, "years");

      that.form.age = year;

      that.form.birthday = valueStr;
      that.form.isUnkownBirthday = 0;

      //计算 valueStr 时间到现在的间隔年份
    },
    onlyDigits(event) {
      const value = event.target.value;
      event.target.value = value.replace(/\D/g, ""); // 使用正则表达式替换非数字字符
    },
    updateUnknownBirthday() {
      //修改生日未知
      let that = this;
      let { isUnkownBirthday } = that.form;
      if (isUnkownBirthday == 1) {
        that.form.isUnkownBirthday = 0;
      } else {
        that.form.isUnkownBirthday = 1;
        that.form.birthday = "";
      }
    },
    calculateBirthdayByAge() {
      let that = this;
      let { age } = that.form;
      //反算年龄
      that.form.birthday = moment().subtract(age, "years").format("YYYY-01-01");
      that.form.isUnkownBirthday = 0;
    },
    clearSource() {
      let that = this;
      that.source = {
        //患者的三级来源
        sourceId1: "", // 患者来源id1
        sourceName1: "",
        sourceId2: "", // 患者来源id2
        sourceName2: "",
        sourceId3: "", // 患者来源id3
        sourceName3: "",
      };
    },
    getSource1() {
      //获取一级来源
      let that = this;
      that.sourceOptions1 = [];
      that.sourceOptions2 = [];
      that.sourceOptions3 = [];
      return new Promise((resolve, reject) => {
        let subdata = {
          bizType: "2",
          clinicId: that.form.clinicId[0],
          isChain: 0,
          id: 0,
        };
        sourceList(subdata).then((res) => {
          let { data } = res.data;
          that.sourceOptions1 = data;
        });
      });
    },
    getSource2(first = false) {
      //获取二级来源
      let that = this;
      that.sourceOptions2 = [];

      return new Promise((resolve, reject) => {
        let subdata = {
          bizType: "2",
          clinicId: that.form.clinicId[0],
          isChain: 0,
          id: that.source.sourceId1,
        };
        sourceList(subdata).then((res) => {
          let { data } = res.data;
          that.sourceOptions2 = data;
          if (first && data.length > 0) {
            that.source.sourceId2 = data[0].value;
            that.source.sourceName2 = data[0].name;
            that.getStep3buyitem(data[0]);
          }
        });
      });
    },
    showStep1() {
      let that = this;
      that.step1Tip.current = that.source.sourceId1;
      that.step1Tip.isShow = true;
    },
    showStep2() {
      let that = this;
      that.step2Tip.current = that.source.sourceId2;
      that.step2Tip.isShow = true;
    },
    showStep3() {
      let that = this;
      that.step3Tip.current = that.source.sourceId3;
      that.step3Tip.isShow = true;
    },
    //打开选择面板
    selectIdcardType() {
      let that = this;
      that.idcardTypeConfig.isShow = true;
    },
    //确认选择
    confirmIdcardType(e) {
      const that = this;
      const [item] = e;
      that.idcardTypeConfig.idcardTypeText = item.text;
      that.idcardTypeConfig.idcardType = item.value;

      // 如果是身份证类型，并且已经输入了18位身份证号码，自动解析身份证信息
      if (item.value === "1" && that.idcardTypeConfig.idcard.length === 18) {
        that.parseIdCardInfo(that.idcardTypeConfig.idcard);
      }
    },
    step1Select(e) {
      let that = this;
      let item = e[0];

      that.source.sourceId1 = item.value;
      that.source.sourceName1 = item.name;

      that.source.sourceId2 = "";
      that.source.sourceName2 = "";
      that.source.sourceId3 = "";
      that.source.sourceName3 = "";

      //true 选择第一项
      that.getSource2(true);
      //请求二级来源
    },
    step2Select(e) {
      let that = this;
      let item = e[0];

      that.source.sourceId2 = item.value;
      that.source.sourceName2 = item.name;

      that.source.sourceId3 = "";
      that.source.sourceName3 = "";

      that.getStep3buyitem(item);
    },
    getStep3buyitem(item) {
      let that = this;
      let { sourceCode } = item.item;
      if (sourceCode == "L2001" || sourceCode == "L2003") {
        //获取员工
        that.source.showSourceId3 = true;
        that.source.source3Type = 1;
        that.getSource3Emp();
      } else if (sourceCode == "L2002" || sourceCode == "L2005") {
        //显示患者
        that.source.showSourceId3 = true;
        that.source.source3Type = 2;
      } else if (
        sourceCode === "L2047" ||
        sourceCode === "L2587" ||
        sourceCode === "L2588" ||
        sourceCode === "L2586"
      ) {
        //这几个状态都是和之前过往记录相关的因为在创建
        that.source.showSourceId3 = false;
      } else {
        //设置默认
        that.source.showSourceId3 = true;
        that.source.source3Type = 0;
        that.getSource3();
      }
    },
    step3Select(e) {
      //选择了3级来源
      let that = this;
      let item = e[0];
      that.source.sourceId3 = item.value;
      that.source.sourceName3 = item.name;
    },
    getSource3Emp() {
      let arr = ["employee"];
      let that = this;
      getPublickOptions(arr, this.form.clinicId[0]).then((res) => {
        that.empOptions = res[0];
      });
    },
    getSource3() {
      let that = this;
      that.sourceOptions3 = [];
      return new Promise((resolve, reject) => {
        let subdata = {
          bizType: "2",
          clinicId: that.form.clinicId[0],
          isChain: 0,
          id: that.source.sourceId2,
        };
        sourceList(subdata).then((res) => {
          let { data } = res.data;

          that.sourceOptions3 = data;
        });
      });
    },
    showEmptTip() {
      let that = this;
      that.selectEmployeeTip.title = `${that.source.sourceName1}/${that.source.sourceName2}/`;
      that.selectEmployeeTip.current = that.source.sourceId3;
      that.selectEmployeeTip.isShow = true;
    },
    empChange(e) {
      let that = this;

      let { row } = e;
      that.source.sourceId3 = row.value;
      that.source.sourceName3 = row.name;
    },
    selectEmpTipShow() {
      //选择患者弹出
      let that = this;
      that.selectPatientTip.title = `${that.source.sourceName1}/${that.source.sourceName2}/`;
      that.selectPatientTip.clinicId = that.form.clinicId[0];
      that.selectPatientTip.isShow = true;
    },
    selectPatientClick(e) {
      //选中了患者
      let that = this;
      that.source.sourceId3 = e.id;
      that.source.sourceName3 = e.patientName;
    },
    toCreate() {
      let that = this;

      let { form, source, idcardTypeConfig } = that;
      if (form.clinicId.length === 0) {
        showToast("患者归属门店门店");
        return;
      }

      if (func.isEmpty(form.patientName)) {
        showToast("请输入患者姓名");
        return;
      }

      // 验证患者姓名是否为空
      if (func.isEmpty(form.patientName)) {
        showToast("请输入患者姓名");
        return;
      }

      // 验证手机号是否为空
      if (func.isEmpty(form.phone1)) {
        showToast("请输入手机号");
        return;
      }

      if (func.isEmpty(form.workUnit)) {
        showToast("请选择工作单位");
        return;
      }

      //验证手机号码是否大于5位长度 小于 15位长度
      if (form.phone1.length < 5 || form.phone1.length > 15) {
        showToast("请输入正确的手机号码");
        return;
      }

      // 验证类型是否为空
      // if (func.isEmpty(form.patientType)) {
      //   showToast("请选择患者类型");
      //   return;
      // }

      // 验证性别是否为空
      if (func.isEmpty(form.sex)) {
        showToast("请选择性别");
        return;
      }

      // 验证生日或年龄是否确认

      if (form.isUnkownBirthday == "0") {
        // 生日和年龄都为空时提示
        if (func.isEmpty(form.birthday) && func.isEmpty(form.age)) {
          showToast("请输入生日和年龄");
          return;
        }
      }

      // 验证 sourceId1 是否为空
      if (func.isEmpty(source.sourceId1)) {
        showToast("请选择患者一级来源");
        return;
      }

      // 验证 sourceId2 是否为空
      if (func.isEmpty(source.sourceId2)) {
        showToast("请选择患者二级来源");
        return;
      }

      const user = userStore();
      let subForm = {
        corpId: user.corpId,
        cusId: user.cusId,
        clinicId: form.clinicId[0],
        patientName: form.patientName, // 患者姓名
        patientType: form.patientType, // 患者类型
        phone1: form.phone1, // 手机号码
        sex: form.sex, // 性别 来自系统字典 【性别】
        sourceId1: source.sourceId1, // 患者来源id1
        sourceId2: source.sourceId2, // 患者来源id2
        sourceId3: source.sourceId3, // 患者来源id3
        age: form.age, // 年龄
        birthday: form.birthday, // 出生日期（yyyy-MM-dd）
        isUnkownBirthday: form.isUnkownBirthday, // 是否确认生日（1 未知 0已知和 空）
        workUnit: form.workUnit, //工作单位
        idcardType: idcardTypeConfig.idcardType, //证件类型
        idcard: idcardTypeConfig.idcard, //证件号码
      };

      if (form.isUnkownBirthday === 0) {
        subForm.birthday = form.birthday;
        subForm.age = form.age;
      }

      that
        .patientSourceValidation()
        .then((res) => {
          return that.createSub(subForm);
        })
        .then(() => {
          window.location.reload();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    createSub(subForm) {
      let that = this;
      that.loading.showLoading();
      return new Promise((resolve, reject) => {
        quickCreateQWPatientRecord(subForm)
          .then((res) => {
            //这里会自动绑上 刷新一下就可以了
            resolve();
          })
          .finally((res) => {
            that.loading.hideLoading();
          });
      });
    },
    selectWorkshow() {
      let that = this;
      that.SelectWorkUnitTip.current = that.form.workUnit;
      that.SelectWorkUnitTip.isShow = true;
    },
    selectWork(val) {
      let that = this;
      that.form.workUnit = val.name;
    },
    deleteWork() {
      //删除工作单位
      this.form.workUnit = "";
    },
    testShowSourceId3() {
      //验证是否显示第三级来源
      let that = this;
      if (!this.source.showSourceId3) {
        return false;
      }

      if (this.source.source3Type == 0 && this.sourceOptions3.length > 0) {
        return true;
      } else if (this.source.source3Type == 1 || this.source.source3Type == 2) {
        return true;
      } else {
        return false;
      }
    },
    onInputChange(event) {
      // 通过正则表达式替换非数字字符
      event.target.value = event.target.value.replace(/\D/g, "");
    },
    // 证件号码输入事件
    onIdcardInputChange(event) {
      // 通过正则表达式替换非数字字符
      // event.target.value = event.target.value.replace(/\D/g, '');
      // 当证件类型为身份证(1)且长度为18位时，解析身份证信息
      if (
        this.idcardTypeConfig.idcardType === "1" &&
        event.target.value.length === 18
      ) {
        this.parseIdCardInfo(event.target.value);
      }
    },
    // 解析身份证信息
    parseIdCardInfo(idcard) {
      // 验证格式是否正确
      if (!/^\d{17}[\dXx]$/.test(idcard)) {
        return;
      }

      try {
        // 校验身份证有效性
        if (!this.validateIdCard(idcard)) {
          return;
        }

        // 从身份证中提取出生日期
        const year = idcard.substring(6, 10);
        const month = idcard.substring(10, 12);
        const day = idcard.substring(12, 14);

        // 格式化日期
        const birthday = `${year}-${month}-${day}`;

        // 验证日期是否有效
        if (!moment(birthday, "YYYY-MM-DD").isValid()) {
          return;
        }

        // 计算年龄
        const birth = moment(birthday);
        const today = moment();
        const age = today.diff(birth, "years");

        // 设置性别 (身份证第17位：奇数为男，偶数为女)
        // const sexValue = parseInt(idcard.charAt(16)) % 2 === 1 ? "1" : "2";

        // 更新表单信息
        this.form.birthday = birthday;
        this.form.age = age;
        // this.form.sex = sexValue;
        this.form.isUnkownBirthday = "0"; // 设置为已知生日
      } catch (error) {
        //console.error("身份证解析错误:", error);
      }
    },
    // 验证身份证有效性
    validateIdCard(idcard) {
      // 必须为18位
      if (!/^\d{17}[\dXx]$/.test(idcard)) {
        return false;
      }
      // 校验出生日期是否合法且不超过当前时间
      const year = idcard.substring(6, 10);
      const month = idcard.substring(10, 12);
      const day = idcard.substring(12, 14);
      const birthday = `${year}-${month}-${day}`;
      // 使用 moment 校验日期格式
      if (!moment(birthday, "YYYY-MM-DD", true).isValid()) {
        return false;
      }
      // 出生日期不能超过当前时间
      if (moment(birthday).isAfter(moment())) {
        return false;
      }
      return true;
    },
    patientSourceValidation() {
      //患者来源校验
      let that = this;
      let { form, source } = that;

      // let {sourceOptions1,sourceOptions2} = that;
      // let sourceId1list = sourceOptions1;
      // let sourceId2list = sourceOptions2;

      let { sourceOptions1: sourceId1list, sourceOptions2: sourceId2list } =
        that;

      let item2arr = [];
      let sourceId1 = source.sourceId1;
      let sourceId2 = source.sourceId2;
      let sourceId3 = source.sourceId3;

      return new Promise((resolve, reject) => {
        sourceId2list.forEach((item) => {
          //如果 item有系统标记 就将这个值的value放到 item2arr
          if (item.item.sysPresetFlag && item.item.sysPresetFlag == 1) {
            item2arr.push(item.value);
          }
        });

        if (!func.isEmpty(sourceId1)) {
          let item1 = sourceId1list.find((item) => {
            return item.value == sourceId1;
          });
          if (item1.item.sourceCode == "L1002") {
            //是患者来源
            if (!func.isEmpty(sourceId2)) {
              let item2 = sourceId2list.find((item) => {
                return item.value == sourceId2;
              });
              if (item2arr.includes(item2.value) && func.isEmpty(sourceId3)) {
                this.$message.warning("患者介绍必须选择三级来源");
                reject();
              } else {
                resolve();
              }
            }
          } else {
            resolve();
          }
        } else {
          resolve();
        }
      });
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.createContent {
  border-radius: 0.083rem;
  padding: 0.208rem;
  background-color: #fff;
  font-size: 0.292rem;
  text-align: left;

  .inputbox {
    border: none;
    width: 100%;
  }

  .sexBtn {
    font-size: 0.25rem;
    padding: 0.083rem 0.292rem;
    border-radius: 999px;
    color: #666666;
    background-color: #f5f5f5;
    margin-right: 0.208rem;
    &.active {
      color: #fff;
      background-color: #28b8c3;
    }
  }

  .endbtn {
    font-size: 0.25rem;
    padding: 0.083rem 0.292rem;
    border-radius: 999px;
    color: #666666;
    background-color: #f5f5f5;
    margin-right: 0.208rem;
    &.active {
      color: #fff;
      background-color: #28b8c3;
    }
  }

  .endswitch {
    margin-right: 0.208rem;
  }
}

.deffont {
  color: #757575;
}

.deleteicon {
  font-size: 0.333rem;
  color: #ccc;
  padding: 0 0.317rem;
}

.editLine {
  .editLine-title {
    min-width: 1.875rem;
  }
  padding: 0.292rem 0;
  border-bottom: 0.021rem solid #ededed;
}
</style>
